import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import styled from 'styled-components'

import img1 from '@/assets/images/main-sec2-img0.png'
import img from '@/assets/images/main-sec2-img1.png'
import { Nanum_eb_size, Nanum_r_size } from '@/styles/font/NanumSquare'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'

const MainIntroSection = () => {
  const firstImgRef = useRef(null)
  const secondImgRef = useRef(null)
  const isFirstImgInView = useInView(firstImgRef, { once: true, margin: '70px 0px' })
  const isSecondImgInView = useInView(secondImgRef, { once: true, margin: '70px 0px' })

  const fadeVariants = {
    hidden: { opacity: 0, y: 70 },
    visible: { opacity: 1, y: 0 },
  }

  return (
    <Section>
      <IntroWrap>
        <FadInImg
          ref={firstImgRef}
          src={img1}
          alt="service_intro_icon"
          variants={fadeVariants}
          initial="hidden"
          animate={isFirstImgInView ? 'visible' : 'hidden'}
          transition={{
            opacity: { duration: 0.4, ease: 'easeInOut' },
            y: { duration: 0.5, ease: 'easeInOut' },
          }}
        />
        <IntroTextWrap>
          <IntroTitle as="h4">
            아직 할부도 한참 남았는데..
            <br />
            잃어버릴까 걱정되세요?
          </IntroTitle>
          <IntroDescription>
            몇 달 전에 구입한 내 최신 휴대폰, 단말기 가격만 백만원이 넘는데...
            <br />
            혹시나 도난 당하거나, 실수로 잃어버릴까봐 너무 걱정 되시나요?
          </IntroDescription>
        </IntroTextWrap>
      </IntroWrap>
      <IntroWrap>
        <IntroTextWrap>
          <IntroTitle>
            <span>휴대폰분실보호 앱 설치</span>하고
            <br />
            분실 전에 미리 보호하세요!
          </IntroTitle>
          <IntroDescription>
            {`휴대폰 분실 시, 신속하게 실시간 위치를 조회하고 저장된 개인정보를\n 안전하게 보호할 수 있습니다.`}
          </IntroDescription>
        </IntroTextWrap>
        <FadInImg
          ref={secondImgRef}
          src={img}
          alt="service_intro_icon"
          variants={fadeVariants}
          initial="hidden"
          animate={isSecondImgInView ? 'visible' : 'hidden'}
          transition={{
            opacity: { duration: 0.4, ease: 'easeInOut' },
            y: { duration: 0.5, ease: 'easeInOut' },
          }}
        />
      </IntroWrap>
    </Section>
  )
}

export default MainIntroSection

const Section = styled.section`
  max-width: 1020px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  padding: 186px 0 80px;

  ${mediaTablet} {
    row-gap: 170px;
    padding: 72px 0;
  }
`
const IntroWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${mediaTablet} {
    flex-direction: column;

    &:nth-of-type(1) {
      flex-direction: column-reverse;
      row-gap: 60px;
    }

    &:nth-of-type(2) {
      row-gap: 23px;
    }
  }

  ${mediaMobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
`
const IntroTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 32px;

  ${mediaTablet} {
    width: 100%;
    row-gap: 15px;
  }
`
const IntroTitle = styled.h1`
  ${Nanum_eb_size(40)}
  letter-spacing: -2px;

  span {
    ${Nanum_eb_size(40)}
    color: var(--blue);
  }

  ${mediaTablet} {
    ${Nanum_r_size(26)}
    font-weight: 800;

    span {
      ${Nanum_r_size(26)}
      font-weight: 800;
    }
  }
`
const IntroDescription = styled.p`
  ${Nanum_r_size(15)}
  color: var(--gray-28);
  line-height: 1.4;
  white-space: pre-line;

  ${mediaTablet} {
    white-space: normal;
    ${Nanum_r_size(12)}
  }
`

const FadInImg = styled(motion.img)`
  width: 450px;

  ${mediaTablet} {
    width: 312px;
  }
`
